"use strict";
/* Markers */
Object.defineProperty(exports, "__esModule", { value: true });
var MarkerTypeIdentifier;
(function (MarkerTypeIdentifier) {
    MarkerTypeIdentifier[MarkerTypeIdentifier["TEXT"] = 0] = "TEXT";
    MarkerTypeIdentifier[MarkerTypeIdentifier["ATOM"] = 1] = "ATOM";
})(MarkerTypeIdentifier = exports.MarkerTypeIdentifier || (exports.MarkerTypeIdentifier = {}));
/* Markups */
var MarkupTagName;
(function (MarkupTagName) {
    MarkupTagName["a"] = "a";
    MarkupTagName["b"] = "b";
    MarkupTagName["code"] = "code";
    MarkupTagName["em"] = "em";
    MarkupTagName["i"] = "i";
    MarkupTagName["s"] = "s";
    MarkupTagName["strong"] = "strong";
    MarkupTagName["sub"] = "sub";
    MarkupTagName["sup"] = "sup";
    MarkupTagName["u"] = "u";
})(MarkupTagName = exports.MarkupTagName || (exports.MarkupTagName = {}));
/* Sections */
var SectionTypeIdentifier;
(function (SectionTypeIdentifier) {
    SectionTypeIdentifier[SectionTypeIdentifier["MARKUP"] = 1] = "MARKUP";
    SectionTypeIdentifier[SectionTypeIdentifier["IMAGE"] = 2] = "IMAGE";
    SectionTypeIdentifier[SectionTypeIdentifier["LIST"] = 3] = "LIST";
    SectionTypeIdentifier[SectionTypeIdentifier["CARD"] = 10] = "CARD";
})(SectionTypeIdentifier = exports.SectionTypeIdentifier || (exports.SectionTypeIdentifier = {}));
/* Markup sections */
var MarkupSectionTagName;
(function (MarkupSectionTagName) {
    MarkupSectionTagName["aside"] = "aside";
    MarkupSectionTagName["blockquote"] = "blockquote";
    MarkupSectionTagName["h1"] = "h1";
    MarkupSectionTagName["h2"] = "h2";
    MarkupSectionTagName["h3"] = "h3";
    MarkupSectionTagName["h4"] = "h4";
    MarkupSectionTagName["h5"] = "h5";
    MarkupSectionTagName["h6"] = "h6";
    MarkupSectionTagName["p"] = "p";
    MarkupSectionTagName["pull-quote"] = "aside"; // Mobiledoc 0.3.0
})(MarkupSectionTagName = exports.MarkupSectionTagName || (exports.MarkupSectionTagName = {}));
/* Image sections */
var ImageSectionTagName;
(function (ImageSectionTagName) {
    ImageSectionTagName["img"] = "img";
})(ImageSectionTagName = exports.ImageSectionTagName || (exports.ImageSectionTagName = {}));
/* List Section */
var ListSectionTagName;
(function (ListSectionTagName) {
    ListSectionTagName["ul"] = "ul";
    ListSectionTagName["ol"] = "ol";
})(ListSectionTagName = exports.ListSectionTagName || (exports.ListSectionTagName = {}));
var ListItemTagName;
(function (ListItemTagName) {
    ListItemTagName["li"] = "li";
})(ListItemTagName = exports.ListItemTagName || (exports.ListItemTagName = {}));
